import { datasource } from "./datasource";

export const jobBoardDashboardDS = (currentUserId, actions) => () =>
  datasource(currentUserId, actions)("job_board_dashboard", {
    model: {
      id: "id",
      fields: {
        id: {
          type: "string",
        },
        ball_id: {
          type: "string",
        },
        location_id: {
          type: "string",
        },
        operator_id: {
          type: "string",
        },
        date_created: {
          type: "string",
        },
        date_due: {
          type: "string",
        },
        date_completed: {
          type: "string",
        },
        status: {
          type: "string",
        },
        note: {
          type: "string",
        },
        discount: {
          type: "number",
        },
        ball_info: {
          type: "raw",
        },
        job_details: {
          type: "raw",
        },
        created_at: {
          type: "string",
        },
        updated_at: {
          type: "string",
        },
        created_by: {
          type: "string",
        },
        updated_by: {
          type: "string",
        },
        sales_person: {
          type: "string",
        },
        job_location: {
          type: "string",
        },
        sales_person_name: {
          type: "string",
        },
        job_location_name: {
          type: "string",
        },
      },
    },
  });
